import { render, staticRenderFns } from "./eyeDiagnosis.vue?vue&type=template&id=ed90b658&scoped=true&"
import script from "./eyeDiagnosis.vue?vue&type=script&lang=js&"
export * from "./eyeDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./eyeDiagnosis.vue?vue&type=style&index=0&id=ed90b658&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed90b658",
  null
  
)

export default component.exports